import React from "react";
import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from "./ui/accordion";
import { FAQS } from "../data/site";

export default function FAQ() {
  return (
    <section id="faq" data-testid="faq-section" className="bg-cream text-ink py-24 md:py-32 px-5 md:px-10 lg:px-16">
      <div className="grid grid-cols-12 gap-6 mb-12 items-end">
        <div className="col-span-12 md:col-span-7">
          <div className="inline-flex items-center gap-2 bg-ink text-cream rounded-full px-4 py-2 mb-6">
            <span className="font-body text-xs tracking-widest uppercase">FAQ</span>
          </div>
          <h2 className="font-display font-extrabold text-5xl md:text-7xl leading-[0.92]">
            perguntas<br/>antes de <span className="bg-lime px-3 italic rounded-2xl inline-block">começar?</span>
          </h2>
        </div>
        <div className="col-span-12 md:col-span-5">
          <p className="font-body text-base text-ink/70">
            Se não encontrares resposta, fala connosco. Gostamos de perguntas.
          </p>
        </div>
      </div>

      <Accordion type="single" collapsible className="space-y-3">
        {FAQS.map((f, i) => (
          <AccordionItem
            key={i}
            value={`item-${i}`}
            data-testid={`faq-accordion-item-${i}`}
            className="bg-white border-2 border-ink/10 rounded-2xl overflow-hidden hover:border-ink transition-colors"
          >
            <AccordionTrigger
              data-testid={`faq-trigger-${i}`}
              className="font-display font-bold text-xl md:text-2xl text-left px-6 py-5 hover:no-underline hover:text-hot [&[data-state=open]]:bg-lime [&[data-state=open]]:text-ink"
            >
              {f.q}
            </AccordionTrigger>
            <AccordionContent className="font-body text-base leading-relaxed text-ink/75 px-6 pb-6 max-w-3xl">
              {f.a}
            </AccordionContent>
          </AccordionItem>
        ))}
      </Accordion>
    </section>
  );
}
